import { render } from "./ReceiveDelivery.vue?vue&type=template&id=551a9076&scoped=true"
import script from "./ReceiveDelivery.vue?vue&type=script&lang=js"
export * from "./ReceiveDelivery.vue?vue&type=script&lang=js"

import "./ReceiveDelivery.vue?vue&type=style&index=0&id=551a9076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551a9076"]])

export default __exports__